import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import FinalizePrescriptionForm from '../../../../itrust_common/components/authorised/examFormPartial/FinalizePrescriptionForm'

function PrescriptionForm(props) {
  const { defaultTemplate, handleSubmit, prescription, lensesAttributes } = props

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div id="divToPrint">
          <FinalizePrescriptionForm
            template={defaultTemplate}
            isTemplate={false}
            pprops={props}
            prescription={prescription}
            prescriptionModule={{ patient_has_finalized_lenses: prescription?.patient_has_finalized_lenses, patient_has_finalized_glasses: prescription?.patient_has_finalized_glasses }}
            lensesAttributes={lensesAttributes}
          />
        </div>
      </form>
    </>
  )
}

PrescriptionForm = reduxForm({
  form: 'PrescriptionForm',
  enableReinitialize: true
})(PrescriptionForm)

const mapStateToProps = (state) => {
  const { setting: { examTemplate, recommendation: { recommendations }, contactLensCleaningSolution: { contact_lens_cleaning_solutions } }, reports: { editing, report } } = state

  return {
    defaultTemplate: examTemplate.exam_templates.find(item => item.name === 'Default'),
    lensesAttributes: report.finalized_lenses_attributes || [],
    recommendations: recommendations,
    contactLensCleaningSolutions: contact_lens_cleaning_solutions,
    prescription: report,
    initialValues: {
      finalized_lenses_attributes: [],
      finalized_glasses_attributes: [],
      patient_id: editing?.patient_id,
      other_details: editing?.other_details,
      report_type: "quick_action",
      category: 'prescription',
      ...report
    }
  }
}

export default connect(mapStateToProps)(PrescriptionForm);